import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { ModalComponent } from './components/modal/modal.component';
import { DialogData } from './model/dialogData';
import { DialogService } from './services/dialog.service';
import { ErrorService } from './services/error.service';
import { NotificationService } from './services/notification.service';
import { ModalErrorComponent } from '@components/modal-error/modal-error.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'iren-admin-dashboard';
  spinnerActive$: Observable<boolean>;
  isDeveloper$: Observable<boolean>;

  constructor(
    private errorService: ErrorService,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.errorService.getError().subscribe((error) => {
      if (error !== '') {
        this.dialog.open(ModalErrorComponent,{width:'600px',height:'250px',data:{error:error}});
      }
    });

    this.notificationService.getNotification().subscribe((notification) => {
      if (notification !== '') {
        this.snackbar.open(notification, 'Chiudi', {
          duration: 6000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: ['mat-snackbar-green'],
        });
      }
    });

    this.dialogService.getDialog().subscribe((dialog) => {
      if (dialog !== '') {
        this.openModal(dialog);
      }
    });
  }

  openModal(obj: DialogData) {
    const dialogConfig = new MatDialogConfig();
    // Se disableClose = true l'utente non può chiudere la modale cliccando al di fuori di essa
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modal-component';
    dialogConfig.width = '600px';

    dialogConfig.data = {
      name: obj.name,
      title: obj.title,
      description: obj.description,
      actionButtonText: obj.actionButtonText,
      object: obj.object,
    };

    // https://material.angular.io/components/dialog/overview
    const modalDialog = this.dialog.open(ModalComponent, dialogConfig);
  }
}
